import { globalStyle, style } from '@vanilla-extract/css';

import { embla } from '../components/EmblaCarousel/embla.css';

export const testimonialsGrid = style({
  position: 'relative',
  width: '100%',
  gap: 'var(--gap)',

  '@media': {
    'only screen and (--mobile)': {
      gap: 'var(--mobile-gap)',
    },
  },
});

/* Carousel overrides start here */
globalStyle(`${testimonialsGrid} ${embla} .embla`, {
  vars: {
    '--slide-control-background-color': 'var(--testimonials-slider-control-background-color)',
    '--slide-control-text-color': 'var(--testimonials-slider-control-text-color)',
    '--slide-control-border-color': 'var(--testimonials-slider-control-border-color)',
  },
  '@media': {
    '(min-width: 1024px)': {
      vars: {
        '--slide-size': 'var(--testimonials-desktop-slide-size)',
      },
    },
    'only screen and (--mobile)': {
      vars: {
        '--slide-control-background-color':
          'var(--testimonials-mobile-slider-control-background-color, var(--testimonials-slider-control-background-color))',
        '--slide-control-text-color':
          'var(--testimonials-mobile-slider-control-text-color, var(--testimonials-slider-control-text-color))',
        '--slide-control-border-color':
          'var(--testimonials-mobile-slider-control-border-color, var(--testimonials-slider-control-border-color))',
      },
    },
  },
});

globalStyle(`${testimonialsGrid} ${embla} .embla__viewport`, {
  paddingLeft: '0',
  paddingRight: '0',
  overflow: 'hidden',
});
/* Carousel overrides end here */

export const testimonialsElement = style({
  backgroundColor: 'var(--background-color)',
});

export const testimonialsDescription = style({
  color: 'var(--description-text-color)',
  fontFamily: 'var(--description-font-family)',
  textAlign: 'var(--alignment)',
});

export const testimonialsMessage = style({
  color: 'var(--message-text-color)',
  fontFamily: 'var(--message-font-family)',
  textAlign: 'var(--alignment)',
});

export const testimonialsName = style({
  color: 'var(--name-text-color)',
  fontFamily: 'var(--name-font-family)',
  textAlign: 'var(--alignment)',
});
